<template>
    <modal
        :saveAction="save"
        :title="$t(title)"
        :id="id"
        :deleteAction="specialtyModel._id ? specialtyModel.can_delete ? deleteAction : false : false"
        :actionButtons="!hideForm"
        size="lg"
        :closeButton="hideForm"
        @shown="shown() "
    >
        <div class="row align-items-center mb-2">
            <div class="col-4">
                <b-form-group :label="$t('Label')">
                    <b-form-input v-model="specialtyModel.label" :placeholder="$t('Ex.: Therapist')"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-4">
                <b-form-group :label="$t('Code')">
                    <b-form-input v-model="specialtyModel.codename" :placeholder="$t('Ex.: therapist')"></b-form-input>
                </b-form-group>
            </div>

            <div class="col-2">
                <b-form-group :label="$t('Language')">
                    <b-form-select v-model="specialtyModel.language" :options="languages"></b-form-select>
                </b-form-group>
            </div>
        </div>
        <div class="row">
            <div class="col-6 col-md-12" v-for="(item, index) in specialtyModel.icd" :key="index">
                <div class="card mb-1">
                    <div class="card-body p-2">
                        <div class="row align-items-center">
                            <div class="col">
                                <strong>{{item.code}}</strong>
                                {{item.label}}
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-white btn-sm mr-1" @click="removeDiangosis(index)">
                                    <i class="fe fe-x"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col">
                <button class="btn btn-white" @click="openModal({ id: 'ICDModal' });">
                    <i class="fe fe-activity"></i>
                    {{$t('Select diagnosis')}}
                </button>
            </div>
        </div>
        <i-c-d-modal id="ICDModal" :useAction="use"></i-c-d-modal>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import ICDModal from '@/components/ICD10/ICDModal.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'


export default {
    name: 'specialty-modal',
    props: ['id', 'saveAction', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,
        ICDModal
    },
    data() {
        return {
            complaints: [{}],
            loading: false,
            hideForm: false,
            languages: [
                { text: 'English', value: 'english' },
                { text: 'Russian', value: 'russian' },
            ],
            specialtyModel: {
                language: 'russian'
            },
            title: 'Specialty',
        }
    },
    computed: {

    },
    mounted() {

        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
        })
        return this.find({ query: {} }).data;

    },

    methods: {
        ...mapActions('specialty', ['find', 'create', 'patch', 'remove']),
        deleteAction() {
            this.remove(this.specialtyModel._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Item has been removed')
                });
            });
        },

        save() {
            let promise, successMessage;

            this.specialtyModel.icd = this.specialtyModel.icd.map(item => {
                return item._id;
            });

            if (this.specialtyModel._id) {
                promise = this.patch([this.specialtyModel._id, this.specialtyModel]);
                successMessage = this.$t('Item has been updated');
            } else {
                promise = this.create(this.specialtyModel);
                successMessage = this.$t('Item has been created');
            }


            promise.then(result => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });
        },

        shown() {
            /* Switch back to the first tab */
            this.specialtyModel = this.data;
            if (!this.data.icd) {
                this.$set(this.specialtyModel, 'icd', []);
            }

        },
        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        },
        removeDiangosis(index) {
            this.specialtyModel.icd.splice(index, 1);
        },
        use(item) {
            this.specialtyModel.icd.push(item);
        },

    },

}
</script>
<style>
.pre-formatted {
  white-space: pre;
}
</style>
